// extracted by mini-css-extract-plugin
export default {"contentOpen":"DropdownContent_contentOpen__afjRQ","fadeIn":"DropdownContent_fadeIn__36BGI","contentClosed":"DropdownContent_contentClosed__LRb2o"};